import { apiClient } from "../api";
import { UpdateContactUsDto, ContactUs } from "../generated/client";



export const getContactUs = async (): Promise<ContactUs> => {
    try {
        const response = await apiClient.contactUs.find();
        return response.data;
    } catch (error) {
        console.error("fetch Contact Us:", error);
        throw error;
    }
};

export const upsertContactUs = async (data: UpdateContactUsDto): Promise<ContactUs> => {
    try {
        const response = await apiClient.contactUs.upsert(data);
        alert("Contact Us saved successfully");
        return response.data;
    } catch (error) {
        console.error("upsert contactUs:", error);
        throw error;
    }
};